<h2 mat-dialog-title>Multiple Merchants</h2>

<mat-dialog-content>
    <p class="form-subtitle">Please select the merchants you want to onboard</p>

    <div class="select-merchant-container" *ngIf="merchants.length > 0">
        <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Merchant</mat-label>
            <mat-select [formControl]="merchantControl" placeholder="Select Merchant">
                <mat-option *ngFor="let merchant of merchants" [value]="merchant.id">
                    <span class="merchant-option-text">{{ merchant.name }}</span>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="center" class="buttons-container">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()"
        [disabled]="merchantControl.value === null || merchantControl.value === undefined">Save</button>
</mat-dialog-actions>